import React, { useState } from 'react';
import { View, TouchableHighlight, Platform, ActivityIndicator, Alert } from 'react-native';
import { Image, Text, Icon } from '@components';
import { BaseColor } from '@config';
import styles from './styles';
import { connect, useDispatch } from 'react-redux';
import Menu from '../Menu';
import { BaseStyle, Images } from '../../config';
import { clientActions } from '../../redux/actions';
import { getImageUrl } from '../../helpers/functions';
import { DeviceType } from 'expo-device';
import { Skeleton } from 'moti/skeleton';
import { MotiView } from 'moti';

function ClientListItem(props) {
    const { item, loading, style, navigation, deleteClient, device, role, userId } = props;
    const [pressed, setpressed] = useState(false);
    const deleteActionAlert = (id) => {
        Alert.alert({
            title: item.name + ' löschen',
            message: 'Achtung!\nBeim Löschen werden alle Aktionen, Märktedaten und Märktebilder gelöscht',
            type: 'error',
            action: [
                { text: 'Löschen', onPress: () => deleteClient(id) },
                { text: 'Abbrechen', onPress: () => { } },
            ],
        });
    };
    const adminAction = () => (
        <View style={{ height: '100%', top: 0, right: 0, position: 'absolute', alignItems: 'center', justifyContent: 'center' }}>
            <Menu
                activator={() => (
                    <View
                        style={[
                            {
                                //backgroundColor: BaseColor.whiteColor,
                                height: 40,
                                width: 40,
                                borderRadius: 15,
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            //Platform.OS == 'android' && BaseStyle.boxWithShadowBottom,
                        ]}
                    >
                        <Icon name="more-vert" type="mi" size={20} color={BaseColor.text} enableRTL={true} />
                    </View>
                )}
                actionItems={[
                    {
                        text: 'Mitglieder',
                        textSecond: "Comming soon",
                        disable: true,
                        leftIcon: () => (
                            <View
                                style={{
                                    backgroundColor: BaseColor.grayLight,
                                    height: 45,
                                    width: 45,
                                    borderRadius: 15,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Icon name="addusergroup" type="ad" size={20} color={BaseColor.text} />
                            </View>
                        ),
                        action: () => navigation.navigate({ name: 'StoreMembers', params: { client: item } }),
                    },
                    {
                        text: 'Positionen',
                        leftIcon: () => (
                            <View
                                style={{
                                    backgroundColor: BaseColor.grayLight,
                                    height: 45,
                                    width: 45,
                                    borderRadius: 15,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Icon name="idcard" type="ad" size={20} color={BaseColor.text} />
                            </View>
                        ),
                        action: () => navigation.navigate({ name: 'Positions', params: { client: item } }),
                    },
                    {
                        text: 'Bearbeiten',
                        leftIcon: () => (
                            <View
                                style={{
                                    backgroundColor: BaseColor.grayLight,
                                    height: 45,
                                    width: 45,
                                    borderRadius: 15,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Icon name="edit" type="ad" size={20} color={BaseColor.text} />
                            </View>
                        ),
                        action: () => navigation.navigate({ name: 'EditClient', params: { client: item } }),
                    },
                    userId == 19
                        ? {
                            text: 'Löschen',
                            leftIcon: () => (
                                <View
                                    style={{
                                        backgroundColor: BaseColor.grayLight,
                                        height: 45,
                                        width: 45,
                                        borderRadius: 15,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Icon name="delete" type="ad" size={20} color={BaseColor.text} />
                                </View>
                            ),
                            action: () => deleteActionAlert(item.id),
                        }
                        : {},
                ]}
            />
        </View>
    );
    const Spacer = ({ height = 16 }) => <View style={{ height }} />;
    const renderGrid = () => {
        if (loading) {
            return (
                <View style={[styles.default, style, { overflow: 'hidden' }]}>
                    <MotiView
                        transition={{
                            type: 'timing',
                        }}
                        style={{ backgroundColor: '#ffffff' }}
                        animate={{ backgroundColor: '#ffffff' }}

                    >
                        <Skeleton radius={3} height={100} width={"100%"} colorMode='light' colors={["#eee", "#efefef", "#fff", "#eee", "#efefef", "#fff", "#eee", "#efefef", "#fff"]} />
                    </MotiView>
                </View>
            );
        }
        return (
            <View style={{ backgroundColor: BaseColor.whiteColor }}>
                <TouchableHighlight
                    underlayColor={'#00000010'}
                    activeOpacity={1}
                    style={{
                        overflow: 'hidden',
                        backgroundColor: BaseColor.whiteColor,
                        //borderBottomColor: BaseColor.grayTransparent,
                        //borderBottomWidth: 1,
                        padding: 10

                    }}
                    onPressIn={() => setpressed(true)}
                    onPressOut={() => setpressed(false)}
                    onPress={() =>
                        navigation.navigate('ActionList', {
                            client: item,
                        })
                    }
                >
                    <View style={{ flexDirection: 'row' }}>
                        <View style={{ borderRadius: 10, borderWidth: 1, borderColor: BaseColor.grayLight }}>
                            {item.logo ? (
                                <Image
                                    style={[styles.girdImage, { height: device != DeviceType.PHONE ? 70 : 70, width: 90, borderRadius: 10 }]}
                                    source={{ uri: getImageUrl(`${item.logo.path}/${item.logo.name}`) }}
                                />
                            ) : (
                                <View
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: '#000',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: device != DeviceType.PHONE ? 70 : 70,
                                        width: 90, borderRadius: 10
                                    }}
                                >
                                    <Text bold title1 primaryColor>
                                        {item.name && item.name[0]}
                                        {item.name && item.name[1]}
                                    </Text>
                                </View>
                            )}
                        </View>
                        <View style={{ padding: 10 }}>
                            <Text semibold numberOfLines={1}>{item.name}</Text>
                            {/* <Text>{item.actions.length} Aktionen</Text> */}
                            <View style={{ paddingTop: 5 }}>
                                <Text footnote grayColor>
                                    {item.description}
                                </Text>
                            </View>
                        </View>
                    </View>
                </TouchableHighlight >
                {role == 1 && !item.deleting && adminAction()
                }
                {
                    item.deleting && (
                        <View style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', transform: [{ scale: 1.1 }] }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', flex: 1, backgroundColor: '#00000080' }}>
                                <ActivityIndicator size={'large'} color={BaseColor.whiteColor} />
                            </View>
                        </View>
                    )
                }
                {/* {pressed && (
                    <View style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', transform: [{ scale: 1.05 }] }}>
                        <View style={{ flex: 1, backgroundColor: '#00000010' }}></View>
                    </View>
                )} */}
            </View >
        );
    };

    return renderGrid();
}

function mapState(state) {
    const { user } = state.users;
    const { device } = state.offlineStorage;
    return { role: user?.roles[0], userId: user.id, device };
}

const actionCreators = {
    deleteClient: clientActions.delete,
};

export default connect(mapState, actionCreators)(ClientListItem);
